import React from 'react';
import './ProfileSkeleton.css'; // We'll create this CSS file next

const ProfileSkeleton = () => (
  <div className="profile-wrapper">
    <div className="profile-section">
      <div className="skeleton profile-photo-skeleton"></div>
      <div className="skeleton skeleton-text"></div>
      <div className="skeleton skeleton-text short"></div>
      <hr />
      <div className="skeleton skeleton-text"></div>
      <div className="skeleton skeleton-text short"></div>
      <div className="skeleton skeleton-text"></div>
    </div>
  </div>
);

export default ProfileSkeleton;